import { render } from "./BottomTwoView.vue?vue&type=template&id=533978ba&scoped=true"
import script from "./BottomTwoView.vue?vue&type=script&lang=js"
export * from "./BottomTwoView.vue?vue&type=script&lang=js"

import "./BottomTwoView.vue?vue&type=style&index=0&id=533978ba&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533978ba"]])

export default __exports__